// extracted by mini-css-extract-plugin
export var card = "_lq-5";
export var cardSelected = "_lq-4";
export var image = "_lq-3";
export var modal = "_lq-0";
export var modalContent = "_lq-1";
export var table = "_lq-2";